import {useMutation, useQueryClient} from '@tanstack/react-query'
import deleteEmployee from './api/deleteEmployee'
import deleteEmployeeQR from 'features/authorized/components/portal/components/qr/common/hooks/common/api/deleteEmployeeQR'

const useDeleteEmployee = ({onSuccess}: {onSuccess: () => void}) => {
    const qc = useQueryClient()
    const onSuccessWrapper = (_: unknown, {qrId}: {qrId: number}) => {
        deleteEmployeeQR(qrId)
        onSuccess()
        qc.invalidateQueries(['employees', 'get'])
    }
    return useMutation(['employee', 'delete'], deleteEmployeeWrapper, {
        onSuccess: onSuccessWrapper,
    })
}
// wrap to get qrId in onSuccess args
const deleteEmployeeWrapper = ({
    employeeId,
}: {
    employeeId: number
    qrId: number
}) => deleteEmployee(employeeId)

export default useDeleteEmployee
